import React, { Component } from "react";

import { Wrapper } from "app/NativeComponents/common";

import HandleView from "./HandleView";

class SlideUpPanelWrapper extends Component {
  togglePanel(is_open) {
    if (this.props.onOpen) {
      this.props.onOpen(is_open);
    }
  }

  render() {
    return (
      <div
        className="deal-sliding-panel closed"
        style={{
          backgroundColor: this.props.colors.card_color
        }}
      >
        <HandleView
          {...this.props}
          onPress={() => this.togglePanel(!this.props.is_open)}
          title={this.props.title}
          subtitle={this.props.subtitle}
          panel_open={this.props.is_open}
          handleComponent={this.props.handleComponent}
        />
        <Wrapper
          className="dm-activity-slider"
          style={{
            height: this.props.is_open ? "80vh" : 0
          }}
        >
          {this.props.panelComponent()}
        </Wrapper>
      </div>
    );
  }
}

export default SlideUpPanelWrapper;
